import { generatePagerProps } from '@fukuri-admins/utils/common/generatePagerProps';
import { useInternalNewsDetail } from './hooks';
import { convertToInternalNewsDetailProps } from './logics';
import { InternalNewsDetailPresentation } from './presentations';

type Props = {
  newsId: number;
};

/**
 * 社内報詳細 Container コンポーネント
 */
export const InternalNewsDetail: React.FC<Props> = ({ newsId }) => {
  const {
    state: {
      newsletterData,
      published,
      activePageTab,
      usersScope,
      activeTab,
      currentPage,
      statisticsData,
      usersData,
      totalPage,
      totalCount,
    },
    actions: {
      handleEdit,
      handlePageTabChange,
      handleUsersScopeChange,
      handleTabChange,
      handlePageChange,
    },
  } = useInternalNewsDetail({ newsId });

  const { article, userUsages, viewRateCard, unreadCount, readCount } =
    convertToInternalNewsDetailProps({
      newsletterData,
      isPublished: published,
      onEdit: handleEdit,
      users: usersData,
      statistics: statisticsData,
    });

  const pagerProps = generatePagerProps({
    currentPage,
    totalPage,
    totalCount,
    rows: userUsages,
    onPageChange: handlePageChange,
  });

  return (
    <InternalNewsDetailPresentation
      article={article}
      activePageTab={activePageTab}
      onPageTabChange={handlePageTabChange}
      usersScope={usersScope}
      onUsersScopeChange={handleUsersScopeChange}
      viewRateCard={viewRateCard}
      activeTab={activeTab}
      unreadCount={unreadCount}
      readCount={readCount}
      onTabChange={handleTabChange}
      userUsages={userUsages}
      pagerProps={pagerProps}
    />
  );
};
